<template>
	<div class="box">
		<div class="logo_box">
			<div class="logo">
				<img @click="goHome" src="@/assets/logo.png">
				<span @click="goHome">贵州省建设工程招标投标协会</span>
			</div>
			<div class="search_box">
				<search></search>
				<div class="user" @click="$refs['vipbox'].showLogin = true;">
					<span class="iconfont icon-chazhaoyonghu"></span>
					<div v-if="userInfo.user.dwmc">{{userInfo.user.dwmc}}</div>
					<div v-else>用户登录</div>
				</div>
			</div>
		</div>
		<div class="menu_box">
			<div class="one_box">
				<div v-for="(it,i) in menuList" :key="i">
					<Tooltip :disabled="it.children.length==0" placement="bottom">
						<div class="one_box" @click="goUrlOne(it,i)" :class="{'selected':current==i}">
							<span class="menu_text">{{it.menuName}}</span>
							<span v-if="it.children.length>0" class="iconfont icon-xiajiantou"></span>
						</div>
						<div v-if="it.children.length>0" slot="content" class="tow_box">
							<div v-for="(tt,ii) in it.children" :key="ii" :class="[tt.children.length==0?'tow_box_canHover':'']" @click="goUrl(tt.path,tt.menuName,i)">
								{{tt.menuName}}
								<!-- <div v-if="tt.children.length>0" class="three_box">
									<div v-for="(kk,jj) in tt.children" :key="jj" @click="goThreeUrl(kk.menuName)">
										{{kk.menuName}}
									</div>
								</div> -->
							</div>
						</div>
					</Tooltip>
				</div>
			</div>
		</div>
		<vipLogin ref="vipbox"></vipLogin>
	</div>
</template>
<script>
	import {
		getMenu,
		getLinks
	} from '@/api/home/index'
	import search from '@/components/search.vue'
	import vipLogin from '@/components/vip_login.vue'
	export default {
		name: 'Header',
		props: {
			isBlue: {
				type: Boolean,
				default: false
			},
			current:{
				type:Number,
				default:0
			}
		},
		components: {
			search,vipLogin
		},
		data() {
			return {
				menuList: [],
				ksUrl:'',
				userInfo:{
					user:{
						username:''
					}
				},
			}
		},
		mounted() {
			this.getLinks();
			this.getMenu();
			if(this.$Cookies.get('userInfo')){
				this.userInfo = JSON.parse(this.$Cookies.get('userInfo'))
			}
		},
		methods: {
			getLinks(){
				getLinks({type:10}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.ksUrl = res.result.url;
					}
				})
			},
			getMenu() {
				getMenu({}).then(res => {
					if (res.code == 200 || res.code == 0) {
						let menuList = res.result;
						menuList.map(it => {
							if (it.menuName == '首页') {
								it.path = '/'
							}
							if (it.children.length > 0) {
								it.children.map(v => {

									if (it.menuName == '行业动态') {
										v.path = 'news'
									}

									if (it.menuName == '党建专栏') {
										v.path = 'party'
									}
									
									if (it.menuName == '工程交易') {
										v.path = 'engineering'
									}
									if (it.menuName == '从业人员') {
										if(v.menuName=='证书查询'){
											v.path = 'certificateLogin'
										}
										if(v.menuName=='从业人员库'){
											v.path = 'people'
										}
									}
									if (it.menuName == '行业信用') {
										v.path = 'trade'
									}
									if (it.menuName == '学习培训') {
										v.path = 'subject'
									}
									if (it.menuName == '关于协会') {
										v.path = 'guild'
									}
									if (it.menuName == '会员中心') {
										v.path = 'member'
									}
								})
							}
						})
						this.menuList = menuList;
					}
				})
			},
			goHome() {
				this.$router.push('/')
			},
			goUrlOne(it,i){
				if(it.menuName=='首页'){
					this.$router.push('/')
				}else if(it.menuName=='行业信用'){
					this.$Message.warning('此功能暂未开放！');
					return
				}else if(it.menuName=='学习培训'){
					this.$Message.warning('此功能暂未开放！');
					return
				}else if(it.children.length==0){
					this.$router.push(it.path)
				}
			},
			goUrl(e, menuName,i) {
				if(menuName=='报名考试'){
					window.open(this.ksUrl)
				}else if(menuName=='从业人员库'){
					if(this.userInfo.user.dwmc==''){
						this.$refs['vipbox'].showLogin = true;
						this.$refs['vipbox'].goRyc = true;
					}else{
						this.$router.push({
							name: e,
							query: {
								name:encodeURIComponent(menuName)
							}
						})
						location.reload()
					}
				}else{
					this.$router.push({
						name: e,
						query: {
							name:encodeURIComponent(menuName)
						}
					})
					location.reload()
				}
			},
			goThreeUrl(name){
				this.$router.push({
					name: 'guild',
					query: {
						name:encodeURIComponent('联系我们'),
						subName:encodeURIComponent(name) 
					}
				})
				location.reload()
			},
		}
	}
</script>
<style lang="scss" scoped>
	.box {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 999;
		padding: 30px 50px;
		color: #fff;
		background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.00) 100%);

		.logo_box {
			display: flex;
			justify-content: space-between;

			.logo {
				display: flex;
				align-items: center;
				font-size: 18px;
				span{
					white-space: nowrap;
					cursor: pointer;
				}

				img {
					width: 60px;
					margin-right: 30px;
					cursor: pointer;
				}
			}

			.search_box {
				display: flex;
				align-items: center;
				padding: 0 50px;
				.user{
					display: flex;
					align-items: center;
					margin-left: 30px;
					font-size: 15px;
					cursor: pointer;
					white-space: nowrap;
					.icon-chazhaoyonghu{
						margin-right: 10px;
					}
				}
			}
		}

		.menu_box {

			.one_box {
				display: flex;
				justify-content: flex-end;
				align-items: center;

				.iconfont {
					margin-left: 5px;
					font-size: 20px;
				}

				>div {
					padding: 10px 25px;
					font-size: 18px;
					cursor: pointer;

					.menu_text {
						white-space: nowrap;
					}
				}

				>div:hover {
					color: #F4DAB4;
				}
			}
			
			.selected{
				color: #F4DAB4;
				font-weight: bold;
			}

			.tow_box {
				text-align: center;

				>div {
					padding: 10px;
					font-size: 15px
				}

				.tow_box_canHover:hover {
					color: #F4DAB4;
				}
			}
			.three_box{
				text-align: right;
				
				>div {
					font-size: 14px;
					margin: 5px 0;
				}
				
				>div:hover {
					color: #F4DAB4;
				}
			}

			::v-deep .ivu-tooltip-inner {
				background-color: #fff;
				color: #011243;
			}
			::v-deep .ivu-tooltip-arrow{
				border-bottom-color:#fff
			}
			
		}
	}
</style>
